( function ( $ ) {
	// Collapsible toggle
	$( '#nav-main__toggler' ).click( function ( e ) {
		e.preventDefault();
		$( this ).toggleClass( 'active' );
		$( '#nav-main__collapsible' ).toggleClass( 'active' );
		$( 'body' ).toggleClass( 'no-scroll' );
		$( '#nav-main.autohide' ).removeClass('autohide--down').addClass('autohide--up');

	} );

	// Hide and show navbar on scroll
	const autoHideElement = $( '#nav-main.autohide' );
	if ( autoHideElement ) {
		let lastScrollTop = 0;
		window.addEventListener( 'scroll', function () {
			const scrollTop = window.scrollY;
			if ( scrollTop < lastScrollTop || scrollTop <= 0) {
				autoHideElement.removeClass( 'autohide--down' );
				autoHideElement.addClass( 'autohide--up' );
			} else {
				if(!$( '#nav-main__collapsible' ).hasClass('active')) {
					autoHideElement.removeClass( 'autohide--up' );
					autoHideElement.addClass( 'autohide--down' );
				}
			}
			lastScrollTop = scrollTop;
		} );
	}
} )( jQuery );
